import * as React from 'react'
import { useParams } from 'react-router-dom'
import ResultDetail from './ResultDetail'

export default function BulkOrderKitsDetail() {
  const { kitId } = useParams()

  return <ResultDetail id={kitId} />
}
